import { render, staticRenderFns } from "./SongRecommendations.vue?vue&type=template&id=e2e63c84&"
import script from "./SongRecommendations.vue?vue&type=script&lang=js&"
export * from "./SongRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports